import React from 'react';
import { QText } from '..';
import { DataProps } from '../../utils';

export type QSubtitleProps = DataProps;

export const QSubtitle: React.FC<QSubtitleProps> = ({ children, ...rest }) => (
  <QText maxWidth="720px" fontSize="sm" {...rest}>
    {children}
  </QText>
);

QSubtitle.displayName = 'QSubtitle';
